// extracted by mini-css-extract-plugin
export default {"root":"TimeSelect_root__chLwS","dropdown":"TimeSelect_dropdown__HzLN7","left":"TimeSelect_left__MI4Ux","right":"TimeSelect_right__vHb8y"};